import { defineMessages } from 'react-intl';

type MessageKeys = 'deactivatedCreatorName';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		deactivatedCreatorName: {
			id: 'rovo-chat.agent-card.deactivated-name',
			defaultMessage: '{name} (deactivated)',
			description: 'Name of the agent creator when it is deactivated',
		},
	});

export default message;
